// Keep hyphenated words (high-net-worth, New York–based) on one line in body
// copy. Browsers always allow a line break after "-" or "–", and CSS can't
// turn that off, so between letters swap "-" for U+2011 (non-breaking hyphen)
// and glue "–" to its neighbours with U+2060 (word joiner).
document.querySelectorAll('#MainContent p').forEach((paragraph) => {
  const walker = document.createTreeWalker(paragraph, NodeFilter.SHOW_TEXT);
  let node;
  while ((node = walker.nextNode())) {
    if (!/[-–]/.test(node.nodeValue)) continue;
    node.nodeValue = node.nodeValue
      .replace(/(\p{L})-(?=\p{L})/gu, '$1‑')
      .replace(/(\p{L})–(?=\p{L})/gu, '$1⁠–⁠');
  }
});
